<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/union/:id', query: { id: unionId } }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item>培训列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>培训列表</span>
          <span class="comment_btn" :class="navTop === '最新' ? 'act' : ''" @click="tabClick('最新')">最新</span>
          <span class="comment_btn" :class="navTop === '最热' ? 'act' : ''" @click="tabClick('最热')">最热</span>
        </p>
        <el-divider></el-divider>
      </div>
      <none-view v-if="trainList.length === 0" :login="trainLoad.login" :loading="trainLoad.loading" :data="trainList" :text="trainLoad.text"></none-view>
      <div class="reception_live_list">
        <div v-for="(item, index) in trainList" :key="item.id" class="reception_live_item" @click = "trainJump(item.is_buy, index)">
          <div class="reception_live_item_top">
            <p class="reception_live_item_top_icon">
              {{item.add_time}}
            </p>
            <img :src="item.img" alt="封面">
          </div>
          <div class="reception_live_item_bottom">
            <dl class="reception_live_info">
              <dt class="reception_live_title">
                <i v-if="item.is_buy === 1 && item.price !== '0.00'" class="reception_live_title_tag">已购买</i>
                {{item.title}}
              </dt>
              <dd class="reception_live_user">
                <span>{{item.user_name}}</span>
              </dd>
            </dl>
            <div class="reception_live_list_item_other">
              <div class="reception_lately_other">
                <span class="reception_lately_price" v-if= "item.price === '0.00'">免费</span>
                <span v-else class="reception_lately_price">￥{{item.price}}</span>
                <el-divider direction="vertical"></el-divider>
                <span><i class="font_i">{{item.read}}</i> 人培训</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="trainList.length > 0" class="hr_page lf">
      <page-button :list = "trainList"
      :limit = "trainMorePage.limit"
      :type = "trainMorePage.type"
      @pageType = "page"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import none from '../Public/none.vue'
import page from '../Public/page.vue'
export default {
  components: {
    noneView: none,
    pageButton: page
  },
  data () {
    return {
      navTop: '最新', // 头部导航
      unionId: '', // 联盟id
      trainLoad: { // 列表加载
        login: false,
        loading: true,
        text: '暂无课程列表',
        data: []
      },
      trainList: [], // 列表
      trainMorePage: { // 列表加载
        limit: 8,
        page: 1,
        union_id: '',
        sort: 2
      }
    }
  },
  created () {
    this.unionId = this.$route.query.id
    this.getTrainList()
  },
  methods: {
    // 头部切换
    tabClick (type) {
      const vueThat = this
      vueThat.trainLoad.loading = true
      vueThat.trainList = []
      if (type === '最新') {
        vueThat.navTop = '最新'
        vueThat.trainMorePage.sort = 2
        vueThat.trainMorePage.page = 1
      } else {
        vueThat.navTop = '最热'
        vueThat.trainMorePage.sort = 1
        vueThat.trainMorePage.page = 1
      }
      vueThat.getTrainList()
    },
    getTrainList () {
      const vueThat = this
      vueThat.trainMorePage.union_id = vueThat.unionId
      vueThat.myApi.unionTrainList(vueThat.trainMorePage).then((res) => {
        if (res.data.code === 200) {
          vueThat.trainLoad.loading = false
          vueThat.trainList.push(...res.data.data.list)
        }
      })
    },
    jump (id) {
      const routeData = this.$router.resolve({
        path: 'trainDetail/:id',
        query: { id: id }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    page (num, type) {
      if (type === 'my') {
        this.myTrainMorePage.page = num
        this.getMyTrainListList()
      } else {
        this.trainMorePage.page = num
        this.getTrainList()
      }
    },
    // 详情跳转
    allJump (type, listId, navId, isDoing) {
      this.mycommon.allJump(this, type, listId, navId, isDoing)
    },
    // 培训跳转
    trainJump (buy, index) {
      if (buy === 0 && this.trainList[index].price !== '0.00') {
        this.$alert('本视频为付费视频，请您下载APP，完成支付！', '温馨提示', {
          type: 'error',
          confirmButtonText: '下载APP',
          showClose: true
        }).then(() => {
          const routeData = this.$router.resolve({
            path: '/down'
          })
          window.open(routeData.href, '_blank')
        })
      } else {
        this.allJump(2, this.trainList[index].list_id, 14)
      }
    }
  }
}
</script>

<style>
</style>
